import { type PropsWithChildren } from 'react'

import { TooltipProvider } from 'slab'

import EmployerProvider, { type EmployerProviderProps } from './EmployerProvider'
import EmployerRenewalAssetProvider, { type EmployerRenewalAssetProviderProps } from './EmployerRenewalAssetProvider'
import EmployerRenewalConfigProvider, { type EmployerRenewalConfigProviderProps } from './EmployerRenewalConfigProvider'
import UserProvider, { type UserProviderProps } from './UserProvider'

export type AppProviderProps = EmployerProviderProps & EmployerRenewalConfigProviderProps & EmployerRenewalAssetProviderProps & UserProviderProps

export default function AppProvider ({
  employerId,
  renewalConfigId,
  hasFinalizedPricing,
  employerIsEstimatedToBeALE,
  userName,
  assetPaths,
  children,
}: PropsWithChildren<AppProviderProps>) {
  return (
    <TooltipProvider>
      <UserProvider userName={userName}>
        <EmployerProvider
          employerId={employerId}
          hasFinalizedPricing={hasFinalizedPricing}
          employerIsEstimatedToBeALE={employerIsEstimatedToBeALE}
        >
          <EmployerRenewalAssetProvider assetPaths={assetPaths}>
            <EmployerRenewalConfigProvider renewalConfigId={renewalConfigId}>
              {children}
            </EmployerRenewalConfigProvider>
          </EmployerRenewalAssetProvider>
        </EmployerProvider>
      </UserProvider>
    </TooltipProvider>
  )
}
